import React, { useState } from 'react';
import ReorderOrderLineButton from '../Components/ReorderOrderLineButton';
import { useDispatch } from 'react-redux';
import { loadError } from '../Actions/Cart.action';
import { cn } from '../Helpers/cn';
import SvgIcon from '../Components/primitives/SvgIcon';
import ContentEditable from 'react-contenteditable';

export default function ReorderOrderLineButtonContainer({
  quantity,
  title,
  label,
  cssClass,
  articleNumber,
  cssButtonClass,
}) {
  const [parsedQuantity, setParsedQuantity] = useState(
    Number.parseInt(quantity)
  );
  const dispatch = useDispatch();

  const inputRef = React.useRef(null);

  // useEffect(() => {
  //   inputRef.current.innerHTML = parsedQuantity;
  // }, [parsedQuantity]);

  async function onError(err) {
    dispatch(loadError(err));
  }

  function onChangeQuantity(e) {
    const value = +e.currentTarget.innerHTML;
    console.log('value is nan', {
      custom: Number.isNaN(String.fromCharCode(value)),
      isNaN: Number.isNaN(value),
      parsed: value,
    });
    if (!Number.isNaN(value) && value > 0) {
      setParsedQuantity(value);
    } else {
      setTimeout(() => {
        inputRef.current.innerHTML = parsedQuantity;
      }, 200);
    }
  }

  function decreaseQuantity(e) {
    if (parsedQuantity > 1) {
      setParsedQuantity((prev) => prev - 1);
    }
  }

  function incrementQuantity(e) {
    setParsedQuantity((prev) => prev + 1);
  }

  return (
    <div className={cn('flex flex-row gap-2', cssClass)}>
      <div className="flex flex-row flex-nowrap">
        <button
          type="button"
          className="size-9 flex items-center justify-center border border-border-primary rounded-l-2xl hover:bg-input-primary"
          onClick={decreaseQuantity}
          disabled={parsedQuantity === 1}
        >
          <SvgIcon.minus className="size-2.5" />
        </button>
        {/* <span
          ref={inputRef}
          // biome-ignore lint/a11y/useSemanticElements: <explanation>
          role="textbox"
          contentEditable
          className="h-9 min-w-9 w-fit px-2 flex items-center justify-center border border-border-primary text-center"
          onInput={onChangeQuantity}
        >
          {parsedQuantity}
        </span> */}

        <ContentEditable
          innerRef={inputRef}
          html={parsedQuantity.toString()} // innerHTML of the editable div
          disabled={false} // use true to disable editing
          onChange={onChangeQuantity} // handle innerHTML change
          tagName="span"
          className="h-9 min-w-9 w-fit px-2 flex items-center justify-center border border-border-primary text-center"
        />
        <button
          type="button"
          className="size-9 flex items-center justify-center border border-border-primary rounded-r-2xl hover:bg-input-primary"
          onClick={incrementQuantity}
        >
          <SvgIcon.plus className="size-2.5" />
        </button>
      </div>
      <ReorderOrderLineButton
        title={title}
        onError={onError}
        label={label}
        cssClass={cssButtonClass}
        articleNumber={articleNumber}
        quantity={parsedQuantity}
      />
    </div>
  );
}
